import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';

export default function ProtectedRoute() {
  const location = useLocation();
  
  // Check if our auth token exists in localStorage
  const isAuthenticated = localStorage.getItem('invoiceAuth') === 'true';

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were 
    // trying to go to so we can drop them off there later.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
}